"use strict";

define('view/dashboard.card',['marionette', 'uikit/mixins/component.mixin', 'uikit/modules/loader', 'uikit/modules/dimmer', 'uikit/elements/button', '../templates'], function (Mn, ComponentMixin, Loader, Dimmer, Button, Templates) {
  var CARD_HEIGHT = 240;
  var BOTTOM_BUTTON_HEIGHT = 36;
  var DashboardCard = Mn.ItemView.extend(ComponentMixin).extend({
    template: Templates.IRB['dashboard.card'],
    ui: {
      body: '.content.body'
    },
    options: {
      large: false,
      collection: null,
      visible: true
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.loader = new Dimmer({
        content: new Loader({
          active: true
        }),
        inverted: true
      });
      this.button = new Button({
        visible: false,
        link: true
      });
      this.button.$el.addClass('attached buttom');
      this.setTableAriaLabelledBy();
    },
    setTableAriaLabelledBy: function setTableAriaLabelledBy() {
      var content = this.getOption('content');
      var header = this.getOption('header');
      if (content instanceof UIKit.Table) {
        content.ariaLabelledby = this.getOption('header').cid;
      }
    },
    onFirstRender: function onFirstRender() {
      if (this.button) {
        this.button.on('change:visible', this.updateContentBodyHeight, this);
      }
      this.updateContentBodyHeight();
    },
    updateContentBodyHeight: function updateContentBodyHeight() {
      if (this.button && this.button.visible) {
        this.ui.body.css('height', CARD_HEIGHT);
      } else {
        this.ui.body.css('height', CARD_HEIGHT + BOTTOM_BUTTON_HEIGHT);
      }
    },
    serializeData: function serializeData() {
      var data = ComponentMixin.serializeData.apply(this, arguments);
      data.button = this.button && !!this.button.visible;
      return data;
    }
  });
  return DashboardCard;
});

